<template>
  <div>
    <div style="float: right">
      <datetime-range
        id="custom-datetime-range"
        :allow-clear="false"
        :default-value="datetimeRange"
        @ok="
          v => {
            datetimeRange = v
          }
        "
      ></datetime-range>
    </div>
    <div style="clear: both"></div>
    <div
      class="module-container"
      style="height: 370px; margin: 16px 1px 0 1px"
    >
      <log-chart-card :get-func="getTrendFunc" :datetime-range="datetimeRange" source="network_device"></log-chart-card>
    </div>

    <div class="module-container" style="min-height: 400px; margin: 16px 1px 0 1px">
      <div class="module-header" style="margin-bottom: 14px">
        详细日志表
      </div>
      <hardware-log-table :get-func="getTableFunc" :datetime-range="datetimeRange" source="network_device"></hardware-log-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getNetworkDeviceSysLogList, getNetworkDeviceSyslogTrend } from '@/api/log'
import DatetimeRange from '@/components/DatetimeRange'
import HardwareLogTable from './modules/HardwareLogTable.vue'
import LogChartCard from './modules/LogChartCard.vue'

export default {
  name: 'NetworkDeviceLog',
  components: {
    DatetimeRange,
    HardwareLogTable,
    LogChartCard
  },
  data () {
    return {
      datetimeRange: [moment().subtract(1, 'hour'), moment()],
      getTableFunc: getNetworkDeviceSysLogList,
      getTrendFunc: getNetworkDeviceSyslogTrend
    }
  }
}
</script>

<style lang="less">
#custom-datetime-range .ant-input {
  border: 1px solid #e5e5e5;
}
.module-container {
  position: relative;
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
}
</style>
